import {FullGameApiModel} from "../../../full-game/models/full-game-api-model";
import {BookmakerDomainModel} from "../../bookmaker/models/bookmaker-domain-model";
import {BookmakerApiModel} from "../../bookmaker/models/bookmaker-api-model";
import {CountryDomainModel} from "../../country/models/country-domain-model";
import {EntityDomainModel} from "../../../../infrastructure/models/entity/entity.domain-model";

export class TvNetworkDomainModel extends EntityDomainModel {
  country: CountryDomainModel;
  bookmaker: BookmakerDomainModel;

  constructor(apiModel: FullGameApiModel, bookmaker: BookmakerApiModel, country: CountryDomainModel) {
    super(apiModel);

    this.country = country;
    this.bookmaker = bookmaker;
  }
}
